// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDRDfdKz-TGYK7lTl7otYNHfo1Uz3opEhk",
    authDomain: "poeticawestfalia.firebaseapp.com",
    projectId: "poeticawestfalia",
    storageBucket: "poeticawestfalia.firebasestorage.app",
    messagingSenderId: "489565716380",
    appId: "1:489565716380:web:c86e6b4f0cdcef92fe1259"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// Init Auth
export const auth = getAuth(app);